import {Button, Grid} from "@material-ui/core";
import {Link as RouterLink} from "react-router-dom";
import React from "react";

export const CancelFormButton = ({url}) => {

    return (<Grid item>
				<Button
					component={RouterLink}
					to={url}
				>
					Cancel
				</Button>
			</Grid>);
}